(ns frontend.view.modals.email-viewer.events
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [frontend.view.modals.events :as modals]
            [frontend.view.modals.email-editor.view :as email-editor-modal]
            [frontend.actions.email :as actions-email]
            [frontend.state.current-session :as session]))

(defn form-not-ready? [entity state]
  (= @state entity))


(defn forward [viewed-entity-id email]
  (let [subject (:email/subject email)]
    (modals/open-modal!
      email-editor-modal/modal-key
      {:title-text              [:span (loc/tr :reply-all)]
       :entity-id               viewed-entity-id
       :body                    (:email/body email)
       :subject                 (if (string/starts-with? subject "FWD:")
                                  subject
                                  (str "FWD: " subject))
       :common/related-entities (:common/related-entities email)
       :on-primary-submit!      (fn [email success! error!]
                                  (actions-email/*->send-email
                                    email
                                    success!
                                    error!))})))

(defn reply-all [viewed-entity-id email]
  (let [subject (:email/subject email)
        from (:email/from email)
        to (:email/to email)
        cc (:email/cc email)]
    (modals/open-modal!
      email-editor-modal/modal-key
      {:title-text              [:span (loc/tr :reply-all)]
       :entity-id               viewed-entity-id
       :body                    (:email/body email)
       :subject                 (if (string/starts-with? subject "RE:")
                                  subject
                                  (str "RE: " subject))
       :common/related-entities (:common/related-entities email)
       :to                      (if (= (:account/nylas-email @session/account) from)
                                  to
                                  (str from "," to))
       :cc                      cc
       :on-primary-submit!      (fn [email success! error!]
                                  (actions-email/*->send-email
                                    email
                                    success!
                                    error!))})))

(defn reply [viewed-entity-id email]
  (let [subject (:email/subject email)
        from (:email/from email)]
    (modals/open-modal!
      email-editor-modal/modal-key
      {:title-text              [:span (loc/tr :reply-all)]
       :entity-id               viewed-entity-id
       :body                    (:email/body email)
       :subject                 (if (string/starts-with? subject "RE:")
                                  subject
                                  (str "RE: " subject))
       :common/related-entities (:common/related-entities email)
       :to                      (str (when-not (= (:account/nylas-email @session/account) from)
                                       from))
       :on-primary-submit!      (fn [email success! error!]
                                  (actions-email/*->send-email
                                    email
                                    success!
                                    error!))})))
